import React, { forwardRef } from 'react';

import CommonNotification from './CommonNotification';
import { ICONS } from '../icons';

const SuccessNotification = forwardRef(
  ({ id, message, subMessage, messageParams, subMessageParams, showMarkerText }, ref) => {
    return (
      <CommonNotification
        id={id}
        ref={ref}
        message={message}
        messageParams={messageParams}
        subMessage={subMessage}
        subMessageParams={subMessageParams}
        showMarkerText={showMarkerText}
        MarkerIcon={ICONS.Tick}
        markerText='success'
        markerStyle='success'
      />
    );
  },
);
SuccessNotification.displayName = 'SuccessNotification';

export default SuccessNotification;
